<template>
  <div class="navigation-overlay">
    <div class="nav-button left" @click.stop="handleClick('previous')"></div>
    <div class="nav-button center"></div>
    <div class="nav-button right" @click.stop="handleClick('next')"></div>
  </div>
</template>

<script setup>
const emit = defineEmits(['navigate']);

const handleClick = (direction) => {
  emit('navigate', direction);
};
</script>

<style lang="scss" scoped>
.navigation-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  pointer-events: none;
  display: flex;
}

.nav-button {
  position: relative;
  height: 100%;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  user-select: none;
  outline: none;
}

.nav-button.left {
  width: 20%;
  left: 0;
  cursor: w-resize;
}

.nav-button.center {
  width: 60%;
  pointer-events: none;
}

.nav-button.right {
  width: 20%;
  right: 0;
  cursor: e-resize;
}
</style>